"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManageBodyComponent = exports.handleAdd = exports.removeToastOnAnyAction = void 0;
/**
 * @module Manage generic component
 *
 * This is the component used accross phone, email, address flows
 * classes, plus any modifier classes and text/text-filled elements if there are any any.
 *
 * NOTE: text will not be positioned in any way by default. Supply a modifier class to position it, if needed.
 *
 * Sample Usage
 * <ManageBodyComponent object='{value}' etc />
 */
var React = require("react");
var constants_1 = require("../constants");
var pp_react_1 = require("@paypalcorp/pp-react");
var addressDisplay_1 = require("../containers/account/address/addressDisplay");
var badges_component_1 = require("../components/badges.component");
var add_new_component_1 = require("../components/add-new.component");
var commonUtils_1 = require("../common/utils/commonUtils");
var ajax_util_1 = require("../utils/ajax/ajax.util");
var phone_1 = require("../utils/container/phone");
var utils_1 = require("../common/utils/phones/utils");
var commonUtils_2 = require("../common/utils/commonUtils");
var page = require("page");
/*
 * This is the fix for toast is not closed when the user performs any operations on the manage page,
 * fix will be removed after the support from pp-react
 */
function removeToastOnAnyAction(props, obj) {
    if (props.typeOfAction) {
        props.performedAction(null);
        if (props.typeOfAction !== "remove") {
            commonUtils_1.modifyObjectWithFactor(obj, props.typeOfAction, true, false);
        }
    }
}
exports.removeToastOnAnyAction = removeToastOnAnyAction;
function handleSetPrimary(type, props, objTobeRendered, event) {
    event.preventDefault();
    var url = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES[type].MAKE_PRIMARY;
    url = url.replace(":id", event.target.value);
    page(url);
    removeToastOnAnyAction(props, objTobeRendered);
}
function handleEdit(type, props, objTobeRendered, event) {
    event.preventDefault();
    var url = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES[type].EDIT;
    url = url.replace(":id", event.target.value);
    page(url);
    removeToastOnAnyAction(props, objTobeRendered);
}
function handleRemove(type, props, objTobeRendered, event) {
    event.preventDefault();
    var url = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES[type].REMOVE;
    url = url.replace(":id", event.target.value);
    page(url);
    removeToastOnAnyAction(props, objTobeRendered);
}
function handleOverFlowMenuClick(url, props, objTobeRendered) {
    page(url);
    removeToastOnAnyAction(props, objTobeRendered);
}
function handleChangePrimary(props, phoneType, objTobeRendered, event) {
    event.preventDefault();
    var url = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.PHONES.CHANGE_PRIMARY;
    url = url.replace(":id", event.target.value);
    props.changePrimaryType(phoneType);
    page(url);
    removeToastOnAnyAction(props, objTobeRendered);
}
function handleAdd(type, props, objTobeRendered, event) {
    event.preventDefault();
    page(constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES[type].ADD);
    removeToastOnAnyAction(props, objTobeRendered);
}
exports.handleAdd = handleAdd;
function menuOptions(commonContent, content) {
    return [
        {
            title: "" + content.managePrimary.button,
            itemLeft: (React.createElement(pp_react_1.Icon, { className: "actionMenu_options", name: "favorite", size: "md" })),
        },
        {
            title: "" + commonContent.edit,
            itemLeft: (React.createElement(pp_react_1.Icon, { className: "actionMenu_options", name: "edit", size: "md" })),
        },
        {
            title: "" + commonContent.remove,
            itemLeft: (React.createElement(pp_react_1.Icon, { className: "actionMenu_options", name: "trash", size: "md" })),
        },
    ];
}
function onSelectionHandler(idx, type, currentObj, props, objTobeRendered) {
    if (idx === 0) {
        handleOverFlowMenuClick((constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES[type].MAKE_PRIMARY).replace(":id", currentObj.state.selectedAddress.id), props, objTobeRendered);
    }
    if (idx === 1) {
        handleOverFlowMenuClick((constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES[type].EDIT).replace(":id", currentObj.state.selectedAddress.id), props, objTobeRendered);
    }
    if (idx === 2) {
        handleOverFlowMenuClick((constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES[type].REMOVE).replace(":id", currentObj.state.selectedAddress.id), props, objTobeRendered);
    }
}
function onMenuClose(currentObj) {
    currentObj.setState({
        selectedAddress: {},
    });
}
function openMenuHandler(eve, valueTobeRendered, currentObj) {
    eve.preventDefault();
    var obj = {};
    obj[valueTobeRendered.id] = true;
    obj["id"] = valueTobeRendered.id;
    currentObj.setState({
        selectedAddress: obj,
    });
}
function ActionMenus(_a) {
    var currentObj = _a.currentObj, valueTobeRendered = _a.valueTobeRendered, commonContent = _a.commonContent, content = _a.content, type = _a.type, props = _a.props, objTobeRendered = _a.objTobeRendered;
    return (React.createElement(pp_react_1.Icon, { className: "overFlowMenu_second", name: "overflow", size: "sm", id: "iconMenu" + valueTobeRendered.id, onClick: function (event) {
            openMenuHandler(event, valueTobeRendered, currentObj);
        } },
        React.createElement(pp_react_1.ActionMenu, { id: "actionMenu" + valueTobeRendered.id, isOpen: currentObj.state.selectedAddress[valueTobeRendered.id]
                ? currentObj.state.selectedAddress[valueTobeRendered.id]
                : false, options: menuOptions(commonContent, content), onSelection: function (idx) {
                return onSelectionHandler(idx, type, currentObj, props, objTobeRendered);
            }, onClose: function () { return onMenuClose(currentObj); } })));
}
function handleResendConfirmation(currentObj, props, objTobeRendered, event, setSpinner) {
    event.preventDefault();
    var url = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.PHONES.VALIDATE_CONFIRMATION, phoneToBeConfirmed = commonUtils_2.findObjectInListById(objTobeRendered, event.target.value);
    url = url.replace(":id", event.target.value);
    var formData = {};
    formData["id"] = event.target.value;
    formData["isTcpaEnabled"] = phone_1.isTcpaEnabled(phoneToBeConfirmed, props);
    formData["isSCAEnabled"] = utils_1.isSCAEnabled(props.features);
    setSpinner(true);
    ajax_util_1.default.post$(props.dispatch, props._csrf, "" + constants_1.default.ROUTES.API.PHONES.CONFIRM, formData, { component: { name: constants_1.default.VIEWS.PHONES.MANAGE } })
        .then(function (phoneInfo) {
        page(url);
    })
        .catch(function (error) {
        page(url);
    });
    removeToastOnAnyAction(props, objTobeRendered);
}
function ItemsList(_a) {
    var _b = _a.type, type = _b === void 0 ? "" : _b, obj = _a.obj, content = _a.content, commonContent = _a.commonContent;
    switch (type) {
        case "ADDRESSES":
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "manageComponent-info" },
                    React.createElement(addressDisplay_1.default, { displayMetadata: obj.displayMetadata })),
                obj && obj.cardList && obj.cardList.length > 0 && (React.createElement("div", { className: "toolTipComponent toolTipComponent_space", role: "toolbar" },
                    React.createElement(pp_react_1.Icon, { className: "cardInfo cardInfo-icon cardInfo_background cardInfo_secondary cardsIcon_secondary", name: "card", size: "xs" }),
                    React.createElement(pp_react_1.Text, { size: "sm", className: "cardInfo cardInfo-icon cardInfo_background cardsIcon_secondary cardsText" }, obj.cardList.length === 1 && content.cards.one
                        ? content.cards.one.replace("{numberOfCards}", obj.cardList.length)
                        : content.cards.info.replace("{numberOfCards}", obj.cardList.length)),
                    React.createElement(pp_react_1.Tooltip, { className: "cardInfo tooltip-description", name: "cardsDetailsToolTip", description: commonUtils_1.cardsDetails(obj.cardList) })))));
        case "PHONES":
            return (React.createElement(React.Fragment, null,
                obj &&
                    obj.type === "MOBILE" &&
                    !obj.confirmed &&
                    phone_1.phoneHasConfirmationFeature(obj.type, obj.isMobileCowConfirmable) && (React.createElement(pp_react_1.Badge, { className: "badgeComponent", type: "critical" }, commonContent.unconfirmed)),
                obj && (React.createElement(pp_react_1.Text, { size: "md", className: "manageComponent-info" }, obj.maskedSubscriberNumber))));
    }
}
function ButtonsList(_a) {
    var currentObj = _a.currentObj, _b = _a.type, type = _b === void 0 ? "" : _b, valueTobeRendered = _a.valueTobeRendered, objTobeRendered = _a.objTobeRendered, content = _a.content, props = _a.props, commonContent = _a.commonContent, fpti = _a.fpti, setSpinner = _a.setSpinner;
    switch (type) {
        case "ADDRESSES":
            return (React.createElement(React.Fragment, null,
                valueTobeRendered && valueTobeRendered.primary && (React.createElement("div", { className: "manageButtons manageButtons_secondary" },
                    React.createElement(pp_react_1.Button, { name: fpti.edit, size: "sm", secondary: true, className: "manageButtons_space manageButtonsBlock_primary", id: "edit-primary", value: valueTobeRendered.id, onClick: function (e) {
                            return handleEdit(type, props, objTobeRendered, e);
                        } }, commonContent.edit),
                    objTobeRendered.length > 1 && (React.createElement(pp_react_1.Button, { name: fpti.remove, size: "sm", secondary: true, className: "manageButtons_space manageButtonsBlock_primary", id: "remove", value: valueTobeRendered.id, onClick: function (e) {
                            return handleRemove(type, props, objTobeRendered, e);
                        } }, commonContent.remove)))),
                valueTobeRendered && !valueTobeRendered.primary && (React.createElement("div", null,
                    React.createElement("div", { className: "editRemoveBlock" },
                        React.createElement("div", { className: "manageButtons manageButtons_secondary" },
                            React.createElement(pp_react_1.Button, { name: fpti.setAsPrimary, size: "sm", className: "manageButtons_space", id: "set-primary-" + valueTobeRendered.id, value: valueTobeRendered.id, secondary: true, onClick: function (e) {
                                    return handleSetPrimary(type, props, objTobeRendered, e);
                                } }, content.managePrimary.button),
                            React.createElement(pp_react_1.Button, { name: fpti.edit, className: "manageButtons_space edit-non-primary", size: "sm", id: "edit-non-primary-" + valueTobeRendered.id, secondary: true, value: valueTobeRendered.id, onClick: function (e) {
                                    return handleEdit(type, props, objTobeRendered, e);
                                } }, commonContent.edit),
                            React.createElement(pp_react_1.Button, { name: fpti.remove, size: "sm", className: "manageButtons_space remove-non-primary", secondary: true, id: "remove-non-primary-" + valueTobeRendered.id, value: valueTobeRendered.id, onClick: function (e) {
                                    return handleRemove(type, props, objTobeRendered, e);
                                } }, commonContent.remove))),
                    React.createElement("div", { className: "overFlowBlock" },
                        React.createElement(pp_react_1.Button, { name: fpti.setAsPrimary, size: "sm", id: "set-primary-overflow-" + valueTobeRendered.id, value: valueTobeRendered.id, secondary: true, onClick: function (e) {
                                return handleSetPrimary(type, props, objTobeRendered, e);
                            } }, content.managePrimary.button),
                        React.createElement(ActionMenus, { currentObj: currentObj, valueTobeRendered: valueTobeRendered, commonContent: commonContent, content: content, props: props, objTobeRendered: objTobeRendered, type: type }))))));
        case "PHONES":
            return (React.createElement(React.Fragment, null, valueTobeRendered && (React.createElement("div", { className: "manageButtons manageButtons_secondary" },
                !valueTobeRendered.primary &&
                    phone_1.canBeSetAsPrimary(valueTobeRendered) && (React.createElement(pp_react_1.Button, { size: "sm", className: "manageButtons_space test_manage_makePrimaryButton", id: "test_manage_makePrimaryButton-" + valueTobeRendered.id, value: valueTobeRendered.id, secondary: true, name: fpti.makePrimary, onClick: function (e) {
                        return handleSetPrimary(type, props, objTobeRendered, e);
                    } }, content.manageMakePrimary.link)),
                valueTobeRendered.type === "MOBILE" &&
                    !valueTobeRendered.confirmed &&
                    phone_1.phoneHasConfirmationFeature(valueTobeRendered.type, valueTobeRendered.isMobileCowConfirmable) && (React.createElement(pp_react_1.Button, { size: "sm", className: "manageButtons_space", value: valueTobeRendered.id, secondary: true, name: fpti.resendConfirmation, onClick: function (e) {
                        return handleResendConfirmation(currentObj, props, objTobeRendered, e, setSpinner);
                    } }, content.manageResendConfirmation.link)),
                !valueTobeRendered.primary && (React.createElement(pp_react_1.Button, { size: "sm", secondary: true, className: "manageButtons_space test_manage_editButton", id: "test_manage_editButton-" + valueTobeRendered.id, value: valueTobeRendered.id, name: fpti.edit, onClick: function (e) {
                        return handleEdit(type, props, objTobeRendered, e);
                    } }, commonContent.edit)),
                valueTobeRendered.primary && (React.createElement(pp_react_1.Button, { size: "sm", secondary: true, className: "manageButtons_space", id: "test_manage_changePrimaryButton-" + valueTobeRendered.id, value: valueTobeRendered.id, name: fpti.changePrimary, onClick: function (e) {
                        return handleChangePrimary(props, valueTobeRendered.type, objTobeRendered, e);
                    } }, commonContent.change)),
                !valueTobeRendered.primary && (React.createElement(pp_react_1.Button, { size: "sm", secondary: true, className: "manageButtons_space test_manage_removeButton", id: "test_manage_removeButton-" + valueTobeRendered.id, value: valueTobeRendered.id, name: fpti.remove, onClick: function (e) {
                        return handleRemove(type, props, objTobeRendered, e);
                    } }, commonContent.remove))))));
    }
}
function ManageBodyComponent(_a) {
    var currentObj = _a.currentObj, _b = _a.objTobeRendered, objTobeRendered = _b === void 0 ? [] : _b, _c = _a.type, type = _c === void 0 ? "" : _c, content = _a.content, commonContent = _a.commonContent, fpti = _a.fpti, props = _a.props, setSpinner = _a.setSpinner;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "manageComponent-header" },
            React.createElement("h2", { className: "manageComponent-header_content" }, content.manage.header),
            React.createElement(pp_react_1.Text, { size: "sm", className: "manageComponent-info_secondary" }, content.manage.info),
            React.createElement(add_new_component_1.AddNewLinkComponent, { type: type, fpti: fpti, content: content, props: props, className: "test_AddNewAddressButton", objTobeRendered: objTobeRendered })),
        React.createElement(pp_react_1.Divider, null),
        objTobeRendered.length > 0 &&
            objTobeRendered.map(function (valueTobeRendered) { return (React.createElement(React.Fragment, null,
                React.createElement(pp_react_1.Container, { fluid: true, className: "manageComponent-header_secondary", id: valueTobeRendered && valueTobeRendered.id },
                    React.createElement(badges_component_1.BadgeByIntentComponent, { commonContent: commonContent, item: valueTobeRendered, type: type, content: content }),
                    React.createElement(ItemsList, { type: type, obj: valueTobeRendered, commonContent: commonContent, content: content }),
                    React.createElement(ButtonsList, { currentObj: currentObj, type: type, valueTobeRendered: valueTobeRendered, objTobeRendered: objTobeRendered, commonContent: commonContent, content: content, props: props, fpti: fpti, setSpinner: setSpinner })),
                React.createElement(pp_react_1.Divider, null))); })));
}
exports.ManageBodyComponent = ManageBodyComponent;
